// extracted by mini-css-extract-plugin
export default {"root":"B2BOverquotaWarningInformer__root--5gFhc","title":"B2BOverquotaWarningInformer__title--hsrow","message":"B2BOverquotaWarningInformer__message--283YN"};